/* eslint-disable */
import React, {useEffect, useState} from 'react';
import "./voucherdetail.style.css";
import Navbar from '../../component/Navbar';
import Layout from '../../component/Layout'
import {loadState, saveState} from "../../_helpers";
import {useLocation, useNavigate} from "react-router-dom";

const VoucherDetail = ({...props}) => {
    let navigate = useNavigate();
    const params = useLocation();

    useEffect(() =>{
        if(params.state === undefined){
            navigate('/voucher-list')
        }
    }, [])

    const [activeTab, setActiveTab] = useState("Term & Condition");
    const tabList = [
        {
          name: "Term & Condition",
        }, {
          name: "How to Use",
        }
    ];

    const changeActiveTab = (tab) => {
      setActiveTab(tab)
    }

    const activeTabContent = (content) => {
      return activeTab === "How to Use" ? content.promotionDescription : content.promotionTerms;
    }

    const useVoucher = (voucher) => {
        const oldVoucher = loadState('voucher') ? loadState('voucher') : [];
        const exists = oldVoucher.some(old => old.productCode === voucher.productCode);
        const newVoucher =
            oldVoucher.length === 0 ?
            [voucher] :
            exists ? loadState('voucher') : [voucher, ...loadState('voucher')]

        saveState('voucher', newVoucher)
        navigate("/payment")

    }

    return (
        <Layout>
            <Navbar title="Detail Voucher" />
            <div className="card">
                <div className="card-image">
                    <figure className="image is-4by3">
                    <img src={params.state.thumbnailUrl !== null && params.state.thumbnailUrl !== "" ? params.state.thumbnailUrl: "https://bulma.io/images/placeholders/1280x960.png"} alt="Placeholder" />
                    </figure>
                </div>
            <div className="card-content">
                <div className="media">
                    <div className="media-left has-text-black">
                        <p>{params.state.merchantName}</p>
                        <p>{params.state.productDescription}</p>
                    </div>
                </div>

                <div className="content">
                    <button className="button pay" style={{width: "100%"}} onClick={() => useVoucher(params.state)}>GUNAKAN VOUCHER INI</button>
                </div>
            </div>
            </div>

            <div className="tabs is-fullwidth pt-4">
                <ul>
                    {tabList.map(t => (
                        <li className={`column p-0 ${t.name === activeTab && "is-active"}`} onClick={() => changeActiveTab(t.name)}>
                            <a>{t.name}</a>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="px-3 pb-5">
                <p style={{ whiteSpace: "pre-line" }} className="has-text-black">{activeTabContent(params.state)}</p>
            </div>
        </Layout>
    )
}

export default VoucherDetail;

